export enum SalariesReport {
    GrossSalaries,
    SalarySpecifications
}